export default function (len: number) {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  random = random + Date.now()
  return random
}
